import { render, staticRenderFns } from "./TerminalAnswer.vue?vue&type=template&id=f73bf5ac&scoped=true&"
import script from "./TerminalAnswer.vue?vue&type=script&lang=js&"
export * from "./TerminalAnswer.vue?vue&type=script&lang=js&"
import style0 from "./TerminalAnswer.vue?vue&type=style&index=0&id=f73bf5ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73bf5ac",
  null
  
)

export default component.exports